import moment from "moment";

export default {
    data() {
        return {
            operationCount: 0,
            infoRecordList: [],
            fields: [
                {key: 'materialNumber', label: '物料号'},
                {key: 'wbsNumber', label: 'WBS'},
            ],
            infoRecordDateFrom: "",
            infoRecordDateEnd: "",
            showDateFilter: false,
            infoRecordDateFromConfig: {label: '操作时间 从', name: 'infoRecordDateFrom', type: 'date'},
            infoRecordDateEndConfig: {label: '操作时间 到', name: 'infoRecordDateEnd', type: 'date'},
        }
    },
    created() {
        this.infoRecordDateFrom = this.formatYesterday
    },
    computed: {
        formatYesterday(){
            return moment().add(-1, 'days').format(this.$t("em.datetime.format.viewMode"));
        }
    },
    methods: {
        getOperationCount(moduleTypeFilter) {
            let queryForm = {}
            queryForm.moduleTypeFilter = moduleTypeFilter;
            queryForm.dateFromFilter = this.formatYesterday;
            let url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesPrdInfoRecord/findOperationCount";
            this.$_emApiMixin_post(url, queryForm)
                .then(response => {
                        this.operationCount = response.data;
                    }
                )
        },
        getInfoRecords(moduleTypeFilter){
            this.showDateFilter = true;
            let queryForm = {}
            queryForm.moduleTypeFilter = moduleTypeFilter;
            queryForm.dateFromFilter = this.infoRecordDateFrom;
            queryForm.dateEndFilter = this.infoRecordDateEnd ? this.infoRecordDateEnd : null;
            this.queryInfoRecords(queryForm)
            this.$refs.infoRecordList.showModal();
        },
        queryInfoRecords(queryForm) {
            let url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesPrdInfoRecord/findByFilter";
            this.$_emApiMixin_post(url, queryForm)
                .then(response => {
                        let tempList = [];
                        for (let row of response.data.list) {
                            let key = row.key;
                            row.materialNumber = key ? key.substring(0, key.indexOf("&")): '';
                            row.wbsNumber = key? key.substring(key.indexOf('&') + 1, key.length): '';
                            tempList.push(row);
                        }
                        this.infoRecordList = tempList;
                    }
                )
        },
        getInfoRecordsByKey(moduleTypeFilter) {
            this.showDateFilter = false;
            let row = this.$store.state[this.modelName].entity;
            let material = row.material ? row.material : row.materialNumber;
            if(material && row.wbsElement){
                let queryForm = {}
                queryForm.moduleTypeFilter = moduleTypeFilter;
                queryForm.keyFilter = material + "&" + row.wbsElement
                this.queryInfoRecords(queryForm)
            }else{
                this.infoRecordList = [];
            }
            this.$refs.infoRecordList.showModal();
        }
    }
}